import DateTime from '@square/dashboard-data/models/squareup/common/time/date-time';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// TODO: These constants are duplicated in ContactNote.
const KEY_NT_BODY = 'squareup.cedas.Note.nt_body';
const KEY_NT_EMPLOYEE_TOKEN = 'squareup.cedas.Note.nt_employee_token';
const KEY_NT_EMPLOYEE_NAME = 'squareup.cedas.Note.nt_employee_name';
export default ProtoBaseModel.extend({
  type: attr(String),
  contactToken: attr(String),
  merchantToken: attr(String),
  unitToken: attr(String),
  eventToken: attr(String),
  occurredAt: attr(DateTime),
  title: attr(String),
  description: attr(String),
  linkRelativeUrl: attr(String),
  getMetadata(scope, field) {
    return this._data[`squareup.cedas.${scope}.${field}`];
  }
}).reopenClass({
  deserialize(data) {
    const record = this._super(data);
    if (data.type === 'Note') {
      // This is needed so that these metadata properties are correctly deserialized.
      record.setProperties({
        body: data[KEY_NT_BODY],
        employeeToken: data[KEY_NT_EMPLOYEE_TOKEN],
        employeeName: data[KEY_NT_EMPLOYEE_NAME]
      });
    }
    return record;
  }
});